/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SignalQualityDto } from './signalQualityDto';
import { NetworkOperatorDto } from './networkOperatorDto';
import { GNSSQualityDto } from './gNSSQualityDto';
import { StorageDto } from './storageDto';

export interface MetaDataDto {
  adapterMac?: string;
  adapterSerial?: string;
  gnssQuality?: GNSSQualityDto;
  networkOperator?: NetworkOperatorDto;
  signalQuality?: SignalQualityDto;
  storage?: StorageDto;
  usbStorage?: StorageDto;
}
